<template>
    <div class="custom-column">
        <div v-if="!params.data.elevator_mode" class="slot-container">
            <!-- Render empty squares -->
            <div v-for="n in params.data.slots" :key="`aqua-${n}`" class="square aqua"></div>
            <div v-for="n in 4 - params.data.slots" :key="`empty-${n}`" class="square empty"></div>
            <!-- Render aqua squares -->
        </div>
        <div v-else class="single-slot">
            <!-- Render a single aqua square with slot type -->
            <div class="square-aqua">
                <div class="square-aqua-title">
                    Elevator Mode
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
};
</script>

<style>
.custom-column {
    display: flex;
    flex-direction: column;
    align-items: start;
}

.slot-container {
    display: flex;
    gap: 4px;
    margin-top: 18px;
}

.square {
    width: 26px;
    height: 14px;
}

.square.empty {
    background-color: #4F5D75;
}

.square.aqua {
    background-color: #0CA2CD;
}

.single-slot {
    display: flex;
    align-items: center;
}

.square-aqua {
    background-color: #0CA2CD;
    color: #10163a;
    margin-top: 12px;
    border-radius: 4px;
}

.square-aqua-title {
    margin-left: 12px;
    margin-right: 12px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
}
</style>
